
















































import { Vue, Component, Watch } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Operations } from '@/http/api_Operations';
import {permissonRoutes} from '@/router';
import {State,Getter,Action,Mutation,namespace} from 'vuex-class'
import Toast from 'vant/lib/toast';
import 'vant/lib/toast/style';
var md5 = require('js-md5');
@Component({
    components: {},
})
export default class Login extends Vue {
    public $refs!: {
        loginForm:HTMLFormElement
    };
    public formRules:any = formRules
    public btnMessage:any = '获取验证码'
    public disYzm = false
    //登录表单
    public loginForm = {
        userName:'',
        password:'',
    }
    public timer = null
    
    showcss = false
    async mounted() {
        
    }
    async created() {
        
    }
    //展示css框子
    showCss(){
        this.showcss = true
    }
    //隐藏css框
    closedcss(){
        this.showcss = false
    }
    /**
     * 登录
     */
     async handleLogin() {
        let obj = {
            account: this.loginForm.userName,
            password: this.loginForm.password
        };
        let res = await Operations.Login(obj)
        localStorage.setItem('internalToken',res.token)
        this.$router.push("/internal/abnormalList")
      
      }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/internalH5/Login.vue